module.exports = __webpack_public_path__ + "static/media/trusted-WACS.aa8d30de.png";